import React, { useState, useEffect, useContext } from "react";
import "./ProductDisplay.css";
import { ShopContext } from "../../Context/ShopContext";
import ConfirmModal from "../../Pages/ConfirmModal.jsx";
import { ReactComponent as Urina } from "../Assets/urina.svg";
import { ReactComponent as Sangue } from "../Assets/sangue.svg";
import { ReactComponent as Fezes } from "../Assets/fezes.svg";
import { ReactComponent as Foto } from "../Assets/ExameFoto.svg";
import { ReactComponent as Clock } from "../Assets/time.svg";
import { ReactComponent as TagIcon } from "../Assets/tag_icon.svg";
import { FaShoppingCart, FaInfoCircle } from "react-icons/fa";
import clinicaConfig from "../../clinicaConfig.js";

const ProductDisplay = (props) => {
  const { product } = props;
  const { addToCart, removeFromCart, cartItems } = useContext(ShopContext);

  const [modalOpen, setModalOpen] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);
  const [activePromotionsForProduct, setActivePromotionsForProduct] = useState([]);
  const [loadingPromotions, setLoadingPromotions] = useState(true);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const API_BASE_URL = clinicaConfig.REACT_APP_API_BASE_URL || 'http://localhost:4000';

  useEffect(() => {
    if (!product || !product.id) return;

    const fetchPromotions = async () => {
      try {
        setLoadingPromotions(true);
        const clientDomain = window.location.hostname;
        const headers = {
          'X-Client-Domain': clientDomain,
          'Content-Type': 'application/json'
        };
        
        const response = await fetch(`${API_BASE_URL}/public/promotions`, { headers });
        if (!response.ok) throw new Error(`Erro: ${response.status}`);
        const data = await response.json();
        
        if (data.success) {
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            const ativas = data.promotions.filter(promo => {
                const inicio = new Date(promo.dataInicio);
                const fim = new Date(promo.dataFim);
                const inicioUTC = new Date(Date.UTC(inicio.getFullYear(), inicio.getMonth(), inicio.getDate()));
                const fimUTC = new Date(Date.UTC(fim.getFullYear(), fim.getMonth(), fim.getDate(), 23, 59, 59, 999));
                const hojeUTC = new Date(Date.UTC(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()));

                const isDateActive = hojeUTC >= inicioUTC && hojeUTC <= fimUTC;
                const isProductIncluded = promo.exames && promo.exames.some(exame => 
                    String(exame.id) === String(product.id) || String(exame._id) === String(product._id)
                );
                return isDateActive && isProductIncluded;
            });
            setActivePromotionsForProduct(ativas);
        }
      } catch (error) {
        console.error("Erro promoções:", error);
      } finally {
        setLoadingPromotions(false);
      }
    };

    fetchPromotions();
  }, [product, API_BASE_URL]);

  const handleRemoveClick = (item) => {
    const itemKey = item.id || item._id;
    if (cartItems[itemKey] === 1) {
      setItemToRemove(item);
      setModalOpen(true);
    } else {
      removeFromCart(itemKey);
    }
  };

  const confirmRemoval = () => {
    const itemKey = itemToRemove.id || itemToRemove._id;
    removeFromCart(itemKey);
    setModalOpen(false);
    setItemToRemove(null);
  };

  const cancelRemoval = () => {
    setModalOpen(false);
    setItemToRemove(null);
  };

  if (!product) return <div>Carregando...</div>;

  const itemKey = product.id || product._id;
  const quantity = cartItems[itemKey] || 0;
  const promotionCount = activePromotionsForProduct.length;

  const getCategoryIcon = () => {
      if (product.category === "Sangue") return <Sangue />;
      if (product.category === "Fezes") return <Fezes />;
      if (product.category === "Urina") return <Urina />;
      return <Foto />;
  };

  const hasPrice = product.old_price && parseFloat(product.old_price) > 0;

  return (
    <div className="productdisplay-section">
      <div className="pd-container">
        
        <div className="pd-header">
            <div className="pd-title-wrapper">
                <div className="pd-title-icon">
                    {getCategoryIcon()}
                </div>
                <div className="pd-title-text">
                    <h1>{product.name}</h1>
                    <div className="pd-meta-tags">
                        <span className="pd-category-tag">
                            {product.category}
                        </span>
                        {product.time_result && (
                            <span className="pd-time-tag">
                                <Clock /> {product.time_result} dias úteis
                            </span>
                        )}
                        {promotionCount > 0 && (
                            <span className="pd-badge-promo-inline">
                                <TagIcon /> Em Promoção
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>

        <div className="pd-content-body">
            <div className="pd-description-box">
                <h3>Sobre o exame</h3>
                <p>{product.description || "Descrição não disponível."}</p>
            </div>

            {product.preparation && (
                <div className="pd-preparation-box">
                    <h3><FaInfoCircle /> Preparo necessário:</h3>
                    <p>{product.preparation}</p>
                </div>
            )}

            {product.information && (
                <div className="pd-information-box">
                    <div className="pd-information-header" onClick={() => setIsInfoOpen(!isInfoOpen)}>
                        <div className="informacao-importante">INFORMAÇÃO IMPORTANTE</div>
                        <span className={`arrow-icon ${isInfoOpen ? "open" : ""}`}></span>
                    </div>
                    {isInfoOpen && (
                        <div className="pd-informacao-conteudo">
                            <p>{product.information}</p>
                        </div>
                    )}
                </div>
            )}

            {!loadingPromotions && promotionCount > 0 && (
                <div className="pd-promotions-box">
                    <h4><TagIcon /> Promoções Ativas:</h4>
                    <ul>
                        {activePromotionsForProduct.map(promo => (
                            <li key={promo._id}>{promo.nome}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>

        <div className="pd-price-action-area">
            {hasPrice && (
                <div className="pd-price-display">
                    <span className="label">Valor do Exame:</span>
                    <span className="value">R$ {parseFloat(product.old_price).toFixed(2).replace('.', ',')}</span>
                </div>
            )}

            <div className="pd-actions" style={{ marginTop: hasPrice ? '0' : 'auto', width: hasPrice ? 'auto' : '100%' }}>
                {quantity > 0 ? (
                    <div className="pd-qty-selector">
                        <button onClick={() => handleRemoveClick(product)}>-</button>
                        <span>{quantity}</span>
                        <button onClick={() => addToCart(itemKey)}>+</button>
                    </div>
                ) : (
                    <button className="pd-btn-add" onClick={() => addToCart(itemKey)}>
                        <FaShoppingCart /> Adicionar ao Carrinho
                    </button>
                )}
            </div>
        </div>

      </div>

      <ConfirmModal
        isOpen={modalOpen}
        onConfirm={confirmRemoval}
        onCancel={cancelRemoval}
        message={<p>Remover <strong>{itemToRemove?.name}</strong> do carrinho?</p>}
      />
    </div>
  );
};

export default ProductDisplay;